module.exports = __webpack_public_path__ + "img/carta.96c19efe.svg";